import { FC, useMemo } from "react";
import IProjetosPropostaInformacoesGarantiaComponentes from "../PropostaDetalhada/types";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import './styles.css';

interface GarantiasProps {
    informacoesGarantia: IProjetosPropostaInformacoesGarantiaComponentes[];
    temServico: boolean;
    componentes: any;
    segmento_projeto?: string;
    avulso?: boolean;
}

const Garantias: FC<GarantiasProps> = ({
    informacoesGarantia,
    temServico,
    componentes,
    segmento_projeto,
    avulso
}) => {

    const categoriasCompParceiros = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro !== "Intelbras" && !(comp.parceiro === "")).map((comp: any) => comp.categoria_componentes_id);
    }, [componentes]);

    const componentesParceiros = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro !== "Intelbras" && !(comp.parceiro === "")).map((comp: any) => comp);
    }, [componentes]);

    const categoriasCompIntelbras = useMemo(() => {
        return componentes.filter((comp: any) => comp.parceiro === "Intelbras" || (comp.parceiro === "")).map((comp: any) => comp.categoria_componentes_id);
    }, [componentes]);
    return <>
        <div className="subTitle bg-verde-intelbras text-white">Garantias</div>

        {!avulso && (<Table component={Paper} size="small" style={{ width: "100%", borderCollapse: "collapse" }} className="table-garantias">
            <TableHead>
                <TableRow>
                    <TableCell className="tableColEquipamentoHead bg-verde-escuro font-intelbras-bold bg-verde-intelbras">Equipamentos</TableCell>
                    <TableCell className="tableColEquipamentoHead bg-verde-escuro font-intelbras-bold bg-verde-intelbras">Garantias</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {informacoesGarantia.filter((item: any) => item?.garantia?.valor > 0).map(item => {
                    let textoGarantiaParceiro = "";
                    if (item.ids.some(id => categoriasCompParceiros.includes(id))) {
                        const componenteParceiro = componentesParceiros.find((comp: any) => comp.categoria_componentes_id === (item.ids.find(id => categoriasCompParceiros.includes(id))));
                        textoGarantiaParceiro = componenteParceiro?.descricao_garantia || "";
                    }
                    return (
                        <>
                            {segmento_projeto === "on" ? <>
                                {item.ids.some(id => categoriasCompParceiros.includes(id)) ?
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            {item.label} de Parceiros
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            {textoGarantiaParceiro || "-"}
                                        </TableCell>
                                    </TableRow> : null}
                                {item.ids.some(id => categoriasCompIntelbras.includes(id)) ?
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            {item.label} Grupo Intelbras
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            {item.garantia.valor} {item.garantia.unidade} de {item.garantia.tipo} {item.performance ? `e ${item.performance.valor} ${item.performance.unidade} de performance` : ''}
                                        </TableCell>
                                    </TableRow> : null}
                            </> : 
                                <>
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            {item.label} Grupo Intelbras
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            {item.garantia.valor} {item.garantia.unidade} de {item.garantia.tipo} {item.performance ? `e ${item.performance.valor} ${item.performance.unidade} de performance` : ''}
                                        </TableCell>
                                    </TableRow>
                                {item.ids.some(id => categoriasCompParceiros.includes(id)) ? <>
                                    <TableRow>
                                        <TableCell className="tableColEquipamento">
                                            {item.label} de Parceiros
                                        </TableCell>
                                        <TableCell className="tableColEquipamento">
                                            {textoGarantiaParceiro || "-"}
                                        </TableCell>
                                    </TableRow>
                                </> : null}
                            </>}
                        </>
                    )
                })}
            </TableBody>
        </Table>)}

        <div className="default-text-list" style={{ marginBottom: "12pt", marginTop: "25pt" }}><span>Os prazos, as condições e respectivas exclusões de garantia, estão descritas no manual de cada produto, e deverão ser acionadas junto à revenda.</span></div>
        {!avulso && (
            <div className="default-text-list" style={{ marginBottom: "12pt" }}><span>Os produtos Renovigi, pertencentes ao Grupo Intelbras, entregam a mesma qualidade reconhecida e um pós-venda confiável que garante tranquilidade e suporte completo para seus projetos.</span></div>
        )}
        <div className="default-text-list default-small-text" style={{ fontSize: "11pt" }}><span>*Para informações detalhadas de performance dos produtos, consulte a ficha técnica.</span></div>
    </>
}

export default Garantias;